import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthUtils } from '../../../utils/AuthUtils';
import { EXPIRE_MINUTES } from '../../../constants/IvyConstants';
import _ from 'lodash';
import {IvyAuthorizationTokenAtom} from "../../../recoil/Authorization.recoil";
import {useSetRecoilState} from "recoil";

const Auth = () => {
  const [queryParams] = useSearchParams();
  const navigate = useNavigate();
  const setToken = useSetRecoilState(IvyAuthorizationTokenAtom)

  const accessToken = queryParams.get('accessToken');

  useEffect(() => {
    if (accessToken !== null) {
      const existedToken = AuthUtils.getCookie('token');
      if (accessToken !== existedToken) {
        if (!_.isEmpty(existedToken)) {
          AuthUtils.removeCookie('token'); // 새로운 토큰으로 들어오면 기존 토큰을 삭제한다
        }
        AuthUtils.setCookie('token', accessToken, {
          path: '/',
          secure: false, //TODO:: 추후 https로 바뀔때 true로 변경하기
          maxAge: EXPIRE_MINUTES * 60,
        });
        setToken(accessToken);
        navigate('/', { replace: true });
      }
    }
  }, [queryParams]);

  return <></>;
};

export default Auth;
